/** @format */
//***********************COMPONENT NOT USED***************************

import React, { Component } from "react";

import {
	Button,
	Collapse,
	FormGroup,
	Form,
	CustomInput,
	Label,
	Input,
} from "reactstrap";
import Nouislider from "nouislider-react";

class Filters extends Component {
	constructor(props) {
		super(props);
		console.log("asdsadsad");
		this.state = {
			priceMin: 0,
			priceMax: 2000,
			filterInputs: [],
			collapse: { Size: false, Color: false },
			bicolors: [],
			stock: false,
			bisize: [],
			bispeed: [],
			accsize: [],
			acccolors: [],
			sidebarFilters: [],
		};

		this.priceMin = this.state.priceMin;
		this.priceMax = this.state.priceMax;

		this.onInputChange = this.onInputChange.bind(this);
		this.toggleCollapse = this.toggleCollapse.bind(this);
		this.priceSlider = this.priceSlider.bind(this);
		this.applyFilters = this.applyFilters.bind(this);
		this.setSidebarFilters = this.setSidebarFilters.bind(this);
	}
	componentDidMount() {
		this.setSidebarFilters();
		this.setState({ priceMin: this.props.filterInputs.filterPriceMin });
		this.setState({ priceMax: this.props.filterInputs.filterPriceMax });
		this.setState({ filterInputs: this.props.filterInputs });
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.state.bisize != nextProps.bisize) {
			this.setState({ bisize: nextProps.bisize });
			this.setSidebarFilters();
			return true;
		} else if (this.state.bicolors != nextProps.bicolors) {
			this.setState({ bicolors: nextProps.bicolors });
			this.setSidebarFilters();
			return true;
		} else if (this.state.bispeed != nextProps.bispeed) {
			this.setState({ bispeed: nextProps.bispeed });
			this.setSidebarFilters();
			return true;
		} else if (this.state.accsize != nextProps.accsize) {
			this.setState({ accsize: nextProps.accsize });
			this.setSidebarFilters();
			return true;
		} else if (this.state.acccolors != nextProps.acccolors) {
			this.setState({ acccolors: nextProps.acccolors });
			this.setSidebarFilters();
			return true;
		} else {
			return false;
		}
	}


	setSidebarFilters() {
		const CheckboxesFilter = ({ data, idd }) => (
			<Form className='mt-4 mt-lg-0'>
				{data.map((item) => (
					<FormGroup key={item.value} className='mb-1'>
						<CustomInput
							type='checkbox'
							name={idd}
							id={item.value}
							label={<React.Fragment>{item.name}</React.Fragment>}
							checked={
								this.state.filterInputs[idd]
									? this.state.filterInputs[idd].includes(item.value)
									: ""
							}
							onChange={(e) => this.onInputChange(e)}
						/>
					</FormGroup>
				))}
			</Form>
		);


		var sidebarFilters = [
			{
				component: <CheckboxesFilter data={this.state.stock} idd='stock' />,
				title: "Filter By stock",
				subtitle: "In Stock",
				show: this.state.bisize.length == 0 ? false : true,
			},
			{
				component: <CheckboxesFilter data={this.state.bisize} idd='bisize' />,
				title: "Filter by Bicycle Size",
				subtitle: "Size",
				show: this.state.bisize.length == 0 ? false : true,
			},
			{
				component: <CheckboxesFilter data={this.state.bicolors} idd='bicolor' />,
				title: "Filter by Bicycle Color",
				subtitle: "Color",
				show: this.state.bicolors.length == 0 ? false : true,
			},
			{
				component: <CheckboxesFilter data={this.state.bispeed} idd='bispeed' />,
				title: "Filter by Bicycle Speed",
				subtitle: "Speed",
				show: this.state.bispeed.length == 0 ? false : true,
			},
			{
				component: <CheckboxesFilter data={this.state.accsize} idd='acsize' />,
				title: "Filter by Accessory Size",
				subtitle: "Accessory Size",
				show: this.state.accsize.length == 0 ? false : true,
			},
			{
				component: <CheckboxesFilter data={this.state.acccolors} idd='accolor' />,
				title: "Filter by Accessory Color",
				subtitle: "Accessory Color",
				show: this.state.acccolors.length == 0 ? false : true,
			},
		];

		this.setState({ sidebarFilters: sidebarFilters });
	}

	priceSlider(render, handle, value, un, percent) {
		this.setState({ priceMin: value[0].toFixed(0) });
		this.setState({ priceMax: value[1].toFixed(0) });

		var filterInputs = { ...this.state.filterInputs };
		filterInputs["filterPriceMin"] = value[0].toFixed(0);
		filterInputs["filterPriceMax"] = value[1].toFixed(0);

		this.setState({ filterInputs: filterInputs });
	}

	onInputChange(e) {
		var type = e.target.type; // Input type
		var value = e.target.id; // Input value
		var name = e.target.name; // Input name
		var filters = { ...this.state.filterInputs };

		if (this.state.filterInputs[name]) {
			if (this.state.filterInputs[name].some((item) => item === value)) {
				filters[name] = this.state.filterInputs[name].filter(
					(x) => x !== value
				);
				this.setState({ filterInputs: filters });
			} else {
				filters[name].push(value);
				this.setState({ filterInputs: filters });
			}
		} else {
			filters[name] = [];
			filters[name].push(value);
			this.setState({ filterInputs: filters });
		}

		console.log(this.state);
	}

	applyFilters() {
		this.props.onUpdate(this.state.filterInputs);
	}

	toggleCollapse(name) {
		var collapseState = { ...this.state.collapse };
		collapseState[name] = !collapseState[name];
		this.setState({ collapse: collapseState });
	}

	render() {
		return (
			<React.Fragment>
				{this.state.sidebarFilters.map((filter, index) => (
					<div key={index}>
						{filter.show && (
							<div className='sidebar-block px-3 px-lg-0'>
								<a
									className='d-lg-none block-toggler plp-filter'
									aria-expanded={this.state.collapse[filter.subtitle]}
									onClick={() => this.toggleCollapse(filter.subtitle)}
								>
									{filter.title}
									<span className='block-toggler-icon' />
								</a>

								<Collapse
									isOpen={this.state.collapse[filter.subtitle]}
									className='expand-lg'
								>
									<h5 className='sidebar-heading d-none d-lg-block'>
										{filter.title}
									</h5>

									{filter.component}
								</Collapse>
							</div>
						)}
					</div>
				))}
				<div className='sidebar-block px-3 px-lg-0'>
					<h5 className='sidebar-heading '>Filter by Price</h5>
					<Nouislider
						key={2}
						range={{ min: 0, max: 2000 }}
						start={[this.priceMin, this.priceMax]}
						onUpdate={this.priceSlider}
						className='mt-4 mt-lg-0'
						connect
					/>
					<div className='nouislider-values mb-4'>
						<div className='min'>
							From $
							<span id='slider-snap-value-from'>{this.state.priceMin}</span>
						</div>
						<div className='max'>
							To $<span id='slider-snap-value-to'>{this.state.priceMax}</span>
						</div>
					</div>

					<Button
						color='dark px-3 px-lg-0 mt-5'
						block
						type='button'
						onClick={this.applyFilters}
					>
						Apply Filters
					</Button>
				</div>
			</React.Fragment>
		);
	}
}

export default Filters;
